export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/decor-coupon.3b83e4f9-669cb8.svg";